
import { create } from 'zustand';

export const useKVKKCategoryStore = create((set, get) => ({
  // State
  categories: [],
  selectedCategory: null,
  loading: false,
  error: null,

  // Pagination state (Blueprint compliant)
  pagination: {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 1
  },

  // Search and filter state
  searchParams: {
    search: '',
    sortBy: 'orderIndex',
    sortOrder: 'asc',
    // Filters
    dataType: null,
    isSpecialQualified: null,
    parentId: null,
    status: 'active'
  },

  // Unique values for filters (Blueprint compliant)
  uniqueValues: {},

  // Form handling state
  isFormOpen: false,
  isEditMode: false,
  formData: {
    name: '',
    code: '',
    description: '',
    parentId: null,
    orderIndex: 0,
    isSpecialQualified: false,
    dataType: 'genel',
    status: 'active'
  },

  // Delete handling state
  isDeleteDialogOpen: false,
  categoryToDelete: null,

  // Setters
  setCategories: (categories) => set({ categories }),
  setSelectedCategory: (category) => set({ selectedCategory: category }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  setPaginationData: (pagination) => set({ pagination: { ...get().pagination, ...pagination } }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setSearchParams: (params) => set((state) => ({
    searchParams: { ...state.searchParams, ...params }
  })),

  // Form Actions
  setFormOpen: (isOpen) => set({ isFormOpen: isOpen }),
  setEditMode: (isEdit) => set({ isEditMode: isEdit }),
  setFormData: (data) => set((state) => ({
    formData: { ...state.formData, ...data }
  })),

  resetForm: () => set({
    formData: {
      name: '',
      code: '',
      description: '',
      parentId: null,
      orderIndex: 0,
      isSpecialQualified: false,
      dataType: 'genel',
      status: 'active'
    },
    isEditMode: false,
    selectedCategory: null
  }),

  // Delete Actions
  openDeleteDialog: (category) => set({
    isDeleteDialogOpen: true,
    categoryToDelete: category
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    categoryToDelete: null
  }),



  // Legacy/Helper actions (if still needed by some components)
  openCreateForm: () => {
    get().resetForm();
    set({ isFormOpen: true });
  },

  openEditForm: (category) => {
    set({
      isFormOpen: true,
      isEditMode: true,
      selectedCategory: category,
      formData: {
        name: category.name || '',
        code: category.code || '',
        description: category.description || '',
        parentId: category.parentId || null,
        orderIndex: category.orderIndex || 0,
        isSpecialQualified: category.isSpecialQualified || false,
        dataType: category.dataType || 'genel',
        status: category.status || 'active'
      }
    });
  },

  closeForm: () => {
    set({ isFormOpen: false });
    get().resetForm();
  }
}));

export default useKVKKCategoryStore;
